import { useState } from "react";

import { Colors, Icon, Portal } from "@blueprintjs/core";

import { SettingsSideNavContent } from "@/components/nav/SettingsSideNav";
import { HeaderButton } from "@/components/pieces/button/HeaderButton";
import { Clickable } from "@/components/pieces/interaction/Clickable";
import { NAV_Z_INDEX } from "@/css/constants";

interface SettingsMenuButtonProps {
  pageLoading?: boolean;
}

export function SettingsMenuButton({
  pageLoading = false,
}: SettingsMenuButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <HeaderButton icon="menu" onClick={() => setIsOpen(true)} />

      <Portal>
        <Clickable onClick={() => setIsOpen(false)}>
          <div
            className={`fixed top-0 left-0 right-0 bottom-0 bg-black transition-opacity duration-300 ease-in-out ${
              isOpen ? "opacity-50" : "opacity-0 pointer-events-none"
            }`}
            style={{
              zIndex: NAV_Z_INDEX + 1,
            }}
          />
        </Clickable>
        <div
          className={`fixed top-0 left-0 bottom-0 w-full sm:w-[280px] bg-white border-r border-gray-300 overflow-auto transition-all duration-300 ease-in-out ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          }`}
          style={{
            zIndex: NAV_Z_INDEX + 1,
          }}
        >
          <div>
            <div className="flex justify-between items-center pl-3">
              <div>
                <h4>Settings</h4>
              </div>
              <div>
                <Clickable onClick={() => setIsOpen(false)}>
                  <div className="p-3">
                    <Icon icon="cross" size={24} color={Colors.DARK_GRAY3} />
                  </div>
                </Clickable>
              </div>
            </div>

            <div>
              <SettingsSideNavContent pageLoading={pageLoading} />
            </div>
          </div>
        </div>
      </Portal>
    </>
  );
}
